import { ApplicationConfiguration, CurrentUserDto } from '@abp/ng.core';
import { Component, Inject, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThemeMetronic } from '../../models/theme-metronic';
import { ProfilePictureImage, PROFILE_PICTURE } from '@hedou/abp.metronic-ui';
import {ProfileService} from '@abp/ng.identity'

@Component({
	selector: 'abp-current-user-image',
	template: `
    <ng-container *ngIf="profilePicture$ | async as pP">
		<ng-container [ngSwitch]="pP.type">
			<img *ngSwitchCase="'image'" [src]="pP.source" alt="user" [ngClass]="classes" />
			<i *ngSwitchCase="'icon'" [ngClass]="pP.source + ' ' + classes"></i>
		</ng-container>
    </ng-container>
	`,
	styleUrls: ['./current-user-image.component.less']
})
export class CurrentUserImageComponent implements ThemeMetronic.CurrentUserImageComponentInputs {

	@Input() currentUser?: CurrentUserDto;

	constructor(
		@Inject(PROFILE_PICTURE) public profilePicture$: BehaviorSubject<ProfilePictureImage>,
		profileService:ProfileService) {
			// profileService.get().subscribe(profile=>{
			// 	profilePicture$.next({
			// 		// source:profile.email
			// 	});
			// });
		
	}

	

	classes: string;


}
